export const MuiDialogContent = () => ({
  root: {
    padding: '0 30px'
  }
});
